import {signal, html, clone, traverse, effect, attr, on, to_number, append, css, define} from "@intrnl/velvet/internal";
import {generatePassword} from './generator.js';
import '~/style.css';
let template0 = html("<h3>random password generator</h3> <form> <div class=password> <input readonly /> <button type=button>copy</button> <button type=submit>generate</button> </div> <hr /> <label> <span>length</span> <input required type=number min=1 /> </label> <label> <span>lowercase</span> <input required type=number min=-1 /> </label> <label> <span>uppercase</span> <input required type=number min=-1 /> </label> <label> <span>number</span> <input required type=number min=-1 /> </label> <label> <span>special</span> <input required type=number min=-1 /> </label> <label> <span>ambiguous</span> <input type=checkbox /> </label> <hr /> <p> <a target=_blank href=https://codeberg.org/intrnl/random-password-generator> source code </a> </p> </form>");
let style0 = css("*,*:before,*:after{box-sizing:border-box}h3,form,label{margin-top:0;margin-bottom:16px}h3,form{display:block}label{display:flex;align-items:center;justify-content:space-between}label>span{display:block;margin-bottom:4px;flex-grow:1}input,button{padding:8px;height:36px}input{font-family:monospace}.password{display:flex;gap:8px}.password input{width:-moz-available;width:-webkit-fill-available;width:fill-available}hr{color:transparent;border:0;border-bottom:1px solid #808080;margin:16px 0}a{text-decoration:none}a:hover{text-decoration:underline}");
function setup($$root, $$host) {
  let length = signal(16);
  let lowercase = signal(1);
  let uppercase = signal(1);
  let number = signal(1);
  let special = signal(1);
  let ambiguous = signal(false);
  let password = signal('');
  let textfield = signal();
  function generate(ev) {
    if (ev) {
      ev.preventDefault();
    }
    password.value = generatePassword({
      length: length.value,
      lowercase: lowercase.value,
      uppercase: uppercase.value,
      number: number.value,
      special: special.value,
      ambiguous: ambiguous.value
    });
  }
  function copy() {
    textfield.value.select();
    document.execCommand('copy');
  }
  generate();
  let fragment0 = clone(template0);
  let child0 = traverse(fragment0, [2, 1, 1]);
  let child1 = traverse(fragment0, [2, 1, 3]);
  let child2 = traverse(fragment0, [2, 5, 3]);
  let child3 = traverse(fragment0, [2, 7, 3]);
  let child4 = traverse(fragment0, [2, 9, 3]);
  let child5 = traverse(fragment0, [2, 11, 3]);
  let child6 = traverse(fragment0, [2, 13, 3]);
  let child7 = traverse(fragment0, [2, 15, 3]);
  let child8 = traverse(fragment0, [2]);
  effect(() => attr(child0, "value", password.value));
  textfield.value = child0;
  on(child1, "click", copy);
  effect(() => child2["value"] = length.value);
  on(child2, "input", () => length.value = to_number(child2.value));
  effect(() => child3["value"] = lowercase.value);
  on(child3, "input", () => lowercase.value = to_number(child3.value));
  effect(() => child4["value"] = uppercase.value);
  on(child4, "input", () => uppercase.value = to_number(child4.value));
  effect(() => child5["value"] = number.value);
  on(child5, "input", () => number.value = to_number(child5.value));
  effect(() => child6["value"] = special.value);
  on(child6, "input", () => special.value = to_number(child6.value));
  effect(() => child7["checked"] = ambiguous.value);
  on(child7, "input", () => ambiguous.value = child7.checked);
  on(child8, "submit", generate);
  append($$root, fragment0);
}
export default define("x-app", setup, {}, [style0]);
